// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__9keoe","title":"Images45_title__3aPnl","images":"Images45_images__upwPa"};